import React, {useCallback, useEffect, useRef, useState} from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    Button,
    FormControl,
    FormLabel,
    Input,
    Stack,
    Text,
    CloseButton,
    Box,
    HStack,
    InputGroup,
    InputRightElement,
    Link,
    Flex,
    VStack,
    useToast,
    Textarea,
    ModalFooter,
    List,
    ListItem,
    ListIcon,
    Checkbox,
    Avatar,
    Spacer,
    Icon,
    useDisclosure,
    Progress, Collapse
} from "@chakra-ui/react";
import {
    addDocument,
    appendFilesInDocumentGeneration,
    removeDocument,
    setCeleryTaskID,
    setCurrentChatInput,
    setFilesInDocumentGeneration,
    setFilesUploadingInDocumentGeneration, setIsPricingModalOpen,
    setIsScanActuallyInProgress,
    setIsUploadLoading,
    setIsUploadSourcesModalOpen,
    setMessagesInDocumentGeneration,
    setScanEstimatedSeconds,
    setScanFileID,
    setScanInProgress
} from "../../../redux/reducers";
import {FaCheckCircle} from "react-icons/fa";
import lightTheme from "../../../utils/styles";
import {addDocumentInStorage, getDocumentsInStorage} from "../../../utils/local-storage-helpers";
import {useDropzone} from "react-dropzone";
import {motion} from "framer-motion";
import {CloseIcon} from "@chakra-ui/icons";
import {ImFilePdf} from "react-icons/im";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {SERVER_IP} from "../../../utils/constants";
import {useAuth} from "../../../redux/AuthProvider";
import SignUpScreen1 from "../SignUp/SignUpScreen1";
import SignInScreen1 from "../SignIn/SignInScreen1";
import ScanModal1 from "../Scans/ScanModal1";
import ScanModalIntro1 from "../Scans/ScanModalIntro1";
import { v4 as uuidv4 } from 'uuid';
import {getSessionTokenGeneration} from "../../../utils/pdf-page-helpers";
import {useTranslation} from "react-i18next";
import {SourceLimitBar} from "./SourceLimitBar";
import { ChevronDown, ChevronUp } from 'lucide-react';
import {getMultidoc} from "../../../utils/multi-doc-helpers";
import { setIsViewSourcesModalOpen } from "../../../redux/reducers";
import { setCurrentGeneratePDF, setCurrentGeneratePDFPage, setIsGeneratePDFVisible } from "../../../redux/reducers";
import { addActiveSourcesMultidoc, removeSourceMultidoc } from "../../../utils/multi-doc-helpers";
import {useServerIP} from "../../../redux/ServerIPContext";
import {
    completeMultipartUploadConversion,
    initiateMultipartUploadConversion,
    uploadMultipartPartsConversion
} from "../../../utils/multipartUploadConversion";
import {getFileExtension} from "../../../utils/socketRooms";
import {failedPDFNotification} from "../../../utils/api";
import AnimatedProgress from "../../Reuseable/AnimatedProgress";
const MotionBox = motion(Box);

const GeneratePromptScreen2 = ({ isOpenGeneratePromptScreen2, onCloseGeneratePromptScreen2, generation, sessionTokenGeneration }) => {
    const { serverIPs, setServerIPs, isDev } = useServerIP();
    const [isLoading, setIsLoading] = useState(false);
    const toast = useToast();
    const fileInput = useRef();
    const dispatch = useDispatch();
    const isProPlan = useSelector((state) => state.settings.isProPlan);
    const { isOpen: isOpenPricingScreen, onOpen: onOpenPricingScreen, onClose: onClosePricingScreen } = useDisclosure();
    const {t} = useTranslation();

    const { isOpen: isOpenSignUpScreen1, onOpen: onOpenSignUpScreen1, onClose: onCloseSignUpScreen1 } = useDisclosure();
    const { isOpen: isOpenSignInScreen1, onOpen: onOpenSignInScreen1, onClose: onCloseSignInScreen1 } = useDisclosure();
    const { isOpen: isOpenScanModal1, onOpen: onOpenScanModal1, onClose: onCloseScanModal1 } = useDisclosure();
    const { isOpen: isOpenScanModalIntro1, onOpen: onOpenScanModalIntro1, onClose: onCloseScanModalIntro1 } = useDisclosure();

    const auth = useAuth();
    const [intervals, setIntervals] = useState({});
    const generations = useSelector(state => state.documents.savedGenerations);
    const currentGenerationSessionToken = useSelector(state => state.settings.currentGenerationSessionToken);
    const isGeneratePDFVisible = useSelector(state => state.settings.isGeneratePDFVisible);
    const currentGeneratePDF = useSelector(state => state.settings.currentGeneratePDF);
    const currentGeneratePDFPage = useSelector(state => state.settings.currentGeneratePDFPage);
    const [files, setFiles] = useState([]);
    const [pollKey, setPollKey] = useState(null);

    const uploadSources = async () => {
        setIsLoading(true)
        // first, append a new "url" field to each file object. And then only keep the name, id, and url fields
        // const filesToUpload = files.map(file => {
        //     const newFile = { ...file };
        //     newFile.url = URL.createObjectURL(file.file);
        //     delete newFile.file;
        //     delete newFile.type;
        //     delete newFile.size;
        //     delete newFile.progress;
        //     delete newFile.status;
        //     return newFile;
        // });
        //
        // dispatch(appendFilesInDocumentGeneration({ documentID: generation.id, newFiles: files }));
        const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111"
        const start = new Date().getTime() / 1000;

        const response = await getMultidoc(generation.id, userID, serverIPs.SERVER_IP_MULTIDOC);
        const end1 = new Date().getTime() / 1000;
        const duration1 = end1 - start;
        console.log("DURATION OF GET MULTIDOC AFTER CLICKING UPLOAD", duration1);
        if (response) {
            console.log("RESPONSE FROM GET MULTIDOC", response);
            if (response.files) {
                const files = response.files.map((file) => {
                    return {
                        id: file.file_id,
                        name: file.file_name,
                        url: file.url,
                        // isActive: true,
                        isActive: generation.files.find(f => f.id === file.file_id) !== undefined ? generation.files.find(f => f.id === file.file_id).isActive : true
                    }
                });
                addActiveSourcesMultidoc(sessionTokenGeneration, localStorage.getItem("userID"),
                                files.filter(file => file.isActive).map((file) => file.id), serverIPs.SERVER_IP_MULTIDOC).then(r => {
                                    console.log("ADD ACTIVE SOURCE after clicking upload", r);
                                    const end2 = new Date().getTime() / 1000;
                                    const duration2 = end2 - start;
                                    console.log("DURATION OF ADD ACTIVE AFTER CLICKING UPLOAD", duration2);
                                    setIsLoading(false)
                                });
                dispatch(setFilesInDocumentGeneration({documentID: generation.id, newFiles: files}));
                if (!isGeneratePDFVisible) {
                    dispatch(setCurrentGeneratePDF(files[0].url));
                    dispatch(setCurrentGeneratePDFPage(1));
                    dispatch(setIsGeneratePDFVisible(true));
                }
            }
        }

        onCloseGeneratePromptScreen2();



        dispatch(setIsUploadSourcesModalOpen(false));
        dispatch(setIsViewSourcesModalOpen(true));
        setFiles([]);
    };

    const onDrop = useCallback((acceptedFiles) => {
        // console.log("First ACCEPTED FILE", acceptedFiles[0])
        const newFiles = acceptedFiles.map(file => ({
            id: uuidv4(),
            file: file,
            type: file.type,
            name: file.name,
            size: file.size,
            progress: 0,
            animatedProgress: 0, // Track the animated progress for display
            status: 'uploading' // could be 'uploading', 'completed', 'error'
        }));

        // const startIndex = filesUploading.length;
        // newFiles.forEach((fileObj, index) => {
        //     handleFileUpload(fileObj, startIndex + index);
        // });
        // const filesToSet = [...filesUploading, ...newFiles];
        // dispatch(setFilesUploadingInDocumentGeneration({ documentID: generation.id, newFiles: filesToSet }));

        setFiles(prevFiles => {
            // Calculate the starting index for the new files
            const startIndex = prevFiles.length;

            // Schedule uploads for each new file
            newFiles.forEach((fileObj, index) => {
                handleFileUpload(fileObj, startIndex + index);
            });

            return [...prevFiles, ...newFiles];
        });
    }, []);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: 'application/pdf',
        multiple: true,
    });

    const closeModal = async () => {
        console.log("CLIKCED THE X BUTTON");
        if (canCloseModal() && files.length > 0) {
            const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111"

            const response = await getMultidoc(generation.id, userID, serverIPs.SERVER_IP_MULTIDOC);
            if (response) {
                console.log("RESPONSE FROM GET MULTIDOC", response);
                if (response.files) {
                    const files = response.files.map((file) => {
                        return {
                            id: file.file_id,
                            name: file.file_name,
                            url: file.url,
                            // isActive: true,
                            isActive: generation.files.find(f => f.id === file.file_id) !== undefined ? generation.files.find(f => f.id === file.file_id).isActive : true
                        }
                    });
                    addActiveSourcesMultidoc(sessionTokenGeneration, localStorage.getItem("userID"),
                                    files.filter(file => file.isActive).map((file) => file.id), serverIPs.SERVER_IP_MULTIDOC).then(r => {});
                    dispatch(setFilesInDocumentGeneration({documentID: generation.id, newFiles: files}));
                    if (!isGeneratePDFVisible) {
                        dispatch(setCurrentGeneratePDF(files[0].url));
                        dispatch(setCurrentGeneratePDFPage(1));
                        dispatch(setIsGeneratePDFVisible(true));
                    }
                }
            }
            onCloseGeneratePromptScreen2();
            dispatch(setIsUploadSourcesModalOpen(false));
            dispatch(setIsViewSourcesModalOpen(true));
            setFiles([]);
        }
        else if (files.length === 0) {
            onCloseGeneratePromptScreen2();
            dispatch(setIsUploadSourcesModalOpen(false));
            setFiles([]);
        }
        else {
            toast({
                title: t('Processing...'),
                description: t('Please wait until all files are uploaded.'),
                status: "info",
                duration: 9000,
                isClosable: true,
            });
        }
    }

    const canCloseModal = () => {
        // Check if any files are in 'ocring' or 'uploading' status
        const isProcessing = files.some(file => file.status === 'ocring' || file.status === 'uploading' || file.status === 'repairing');
        return !isProcessing; // Return true if no files are processing, false otherwise
    };

    const startDocumentProcessing = async (scanFileID, fileIndex) => {
        try {
            const response = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/pdf/advanced_ocr_repair', {
                user_id: localStorage.getItem('userID') !== null ? localStorage.getItem('userID') : "11111111-1111-1111-1111-111111111111",
                file_id: scanFileID,
                socketio_stream_room: "user_" + localStorage.getItem('userID'),
                // user_id: localStorage.getItem('userID') !== null ? localStorage.getItem('userID') : "11111111-1111-1111-1111-111111111111",
                // file_id: scanFileID,
                // "ocr_type": "multidoc"
            });
            console.log("response from SERVER_IP_MULTIDOC /pdf/advanced_ocr_repair", response)
            if (response.data.status === 200) {
                const start = new Date().getTime() / 1000;
                const key = response.data.message.poll_key;
                console.log("KEY HERE", key)// ← grab the poll_key
                setPollKey(key);
                // setIsOpenScanModal2(true);
                // onCloseScanModal1();
                // setIsLoading(false)
                // dispatch(setCeleryTaskID(response.data.message.celery_task_id))
                // dispatch(setIsScanActuallyInProgress(true))

                // start polling another endpoint to check if the document is ready
                const interval = setInterval(async () => {
                    console.log("Pollkey", response.data.message.poll_key);
                    const res = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/general_progress', {
                        key: response.data.message.poll_key,
                    });
                    console.log("response from SERVER_IP_MULTIDOC /general_progress", res)
                    const prog = res.data.message;
                    if (prog.includes("Finished uploading augmented PDF to s3...")) {
                        setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'completed' } : f));
                        setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                        // const updatedFilesUploading = filesUploading.map((f, i) => i === fileIndex ? { ...f, status: 'completed',
                        // progress: 0} : f);
                        // dispatch(setFilesUploadingInDocumentGeneration({ documentID: generation.id, newFiles: updatedFilesUploading }));

                        const end = new Date().getTime() / 1000;
                        const duration = end - start;
                        console.log("DURATION OF SCAN", duration)

                        // addActiveSourcesMultidoc(sessionTokenGeneration, localStorage.getItem("userID"),
                        //         [scanFileID]);

                        clearInterval(interval);
                        setIntervals(prevIntervals => {
                            const newIntervals = { ...prevIntervals };
                            delete newIntervals[scanFileID];
                            return newIntervals;
                        });
                    }

                        // if (response.data.status === 200) {
                        //     setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'completed' } : f));
                        //     setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                        //     // const updatedFilesUploading = filesUploading.map((f, i) => i === fileIndex ? { ...f, status: 'completed',
                        //     // progress: 0} : f);
                        //     // dispatch(setFilesUploadingInDocumentGeneration({ documentID: generation.id, newFiles: updatedFilesUploading }));
                        //
                        //     const end = new Date().getTime() / 1000;
                        //     const duration = end - start;
                        //     console.log("DURATION OF SCAN", duration)
                        //
                        //     // addActiveSourcesMultidoc(sessionTokenGeneration, localStorage.getItem("userID"),
                        //     //         [scanFileID]);
                        //
                        //     clearInterval(interval);
                        //     setIntervals(prevIntervals => {
                        //         const newIntervals = { ...prevIntervals };
                        //         delete newIntervals[scanFileID];
                        //         return newIntervals;
                        //     });
                    // }
                    else {
                        console.log("still processing")
                        // set the progress of the file to 5% more than it was before. This is a hacky way to make the progress bar move
                        // However, make sure the progress never goes above 99%. So go from 95% to 99% then stop if it ever gets there
                        // console.log("ocr file", files.find(f => f.id === scanFileID))
                        // const estimatedTimeOCR = files.find(f => f.id === scanFileID).estimatedTimeOCR;
                        // let increment = 5;
                        // if (estimatedTimeOCR) {
                        //     increment = 5 / (estimatedTimeOCR / 100);
                        // }
                        // setFiles(files => files.map((f, i) => f.id === scanFileID
                        //     ? { ...f, progress: Math.min(f.progress + increment, 99) } : f));


                            setFiles(files => {
                                const file = files.find(f => f.id === scanFileID);
                                console.log("file", file)
                                const estimatedTimeOCR = file?.estimatedTimeOCR;
                                let increment = 5;
                                if (estimatedTimeOCR) {
                                    increment = 5 / (estimatedTimeOCR / 100);
                                    // round to the nearest integer
                                    increment = Math.round(increment);
                                }

                            return files.map((f, i) => f.id === scanFileID
                                ? { ...f, progress: Math.min(f.progress + increment, 99) } : f);
                        });
                        // const updatedFilesUploading = filesUploading.map((f, i) => i === fileIndex ?
                        //     { ...f, progress: Math.min(f.progress + 5, 99) } : f);
                        // dispatch(setFilesUploadingInDocumentGeneration({ documentID: generation.id, newFiles: updatedFilesUploading }));

                    }
                    // else if (response.data.status === 400) {
                    //     setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'error' } : f));
                    //     setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                    //     toast({
                    //         title: t('Oops, something went wrong. Please cancel and try again.'),
                    //         status: "error",
                    //         duration: null,
                    //         isClosable: true,
                    //     })
                    //     clearInterval(interval)
                    // }
                }, 5000)
                setIntervals(prevIntervals => ({ ...prevIntervals, [scanFileID]: interval }));
            }
        } catch (error) {
            // const updatedFilesUploading = filesUploading.map((f, i) => i === fileIndex ? { ...f, status: 'error',
            //     progress: 0} : f);
            // dispatch(setFilesUploadingInDocumentGeneration({ documentID: generation.id, newFiles: updatedFilesUploading }));
            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'error' } : f));
            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
            console.log("/pdf/ocr error", error);
        }
    };

    const startRepairOcrPolling = (fileIDHere, taskIDHere, index) => {
        setFiles(files => files.map((f, i) => i === index ? { ...f, status: 'repairing', progress: 0, id: fileIDHere } : f));

        const pollInterval = setInterval(async () => {
            try {
                console.log("Polling /progress/", taskIDHere);
                const res = await axios.get(serverIPs.SERVER_IP_MULTIDOC + '/progress/' + taskIDHere);
                console.log("response from SERVER_IP_MULTIDOC /progress/", res);

                if (res.data.state === "SUCCESS") {
                    clearInterval(pollInterval);
                    setIntervals(prevIntervals => {
                        const newIntervals = { ...prevIntervals };
                        delete newIntervals[fileIDHere];
                        return newIntervals;
                    });
                    setFiles(files => files.map((f) => f.id === fileIDHere ? { ...f, status: 'completed', progress: 0 } : f));
                } else if (res.data.state === "FAILURE") {
                    clearInterval(pollInterval);
                    setIntervals(prevIntervals => {
                        const newIntervals = { ...prevIntervals };
                        delete newIntervals[fileIDHere];
                        return newIntervals;
                    });
                    setFiles(files => files.map((f) => f.id === fileIDHere ? { ...f, status: 'error', progress: 0 } : f));

                    const userIDForRemove = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111";
                    await removeSourceMultidoc(
                        userIDForRemove,
                        fileIDHere,
                        generation.id,
                        currentGenerationSessionToken !== "" ? currentGenerationSessionToken : null,
                        serverIPs.SERVER_IP_MULTIDOC
                    );
                } else {
                    setFiles(files => files.map((f) => f.id === fileIDHere
                        ? { ...f, progress: Math.min(f.progress + 6, 99) } : f));
                }
            } catch (error) {
                console.error("/progress/ polling error", error);
                clearInterval(pollInterval);
                setIntervals(prevIntervals => {
                    const newIntervals = { ...prevIntervals };
                    delete newIntervals[fileIDHere];
                    return newIntervals;
                });
                setFiles(files => files.map((f) => f.id === fileIDHere ? { ...f, status: 'error', progress: 0 } : f));
            }
        }, 5000);

        setIntervals(prevIntervals => ({ ...prevIntervals, [fileIDHere]: pollInterval }));
    };

    const startTextConversion = async (userID, text) => {
        const filesLength = files.length;
        const index = filesLength;
        let scanFileID = uuidv4();

        const newTextFile = {
            id: scanFileID,
            file: null,
            type: 'plain text',
            name: `text_${scanFileID}.pdf`,
            size: new Blob([text]).size,     // rough byte size of the text
            progress: 0,
            animatedProgress: 0,
            status: 'uploading',
        };
        setFiles(prev => [...prev, newTextFile]);   // ➜ push to the end

        if (localStorage.getItem("userID") !== null) {
            if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                toast({
                    title: t('(Free Plan) Upload Limit Exceeded!'),
                    status: "info",
                    duration: 9000,
                    isClosable: true,
                    position: "top",
                });
                dispatch(setIsPricingModalOpen(true));
                setFiles(files => files.filter((f, i) => i !== index));
                return;
            }

            setFiles(files => files.map((f, i) => i === index ? {...f, status: 'uploading'} : f));

            try {
                const convertToPDFResponse = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/convert/convert_text_to_pdf', {
                    user_id: userID,
                    text: text,
                    socketio_stream_room: "user_" + localStorage.getItem('userID'),
                });
                console.log("response from /convert/convert_text_to_pdf", convertToPDFResponse)

                if (convertToPDFResponse.data.status === 200) {
                    const convertToPDFResponse_progress_key = convertToPDFResponse.data.message.progress_key;

                    const start = new Date().getTime() / 1000;

                    // start polling another endpoint to check if the document is ready
                    const interval = setInterval(async () => {
                        console.log("Pollkey", convertToPDFResponse_progress_key);
                        const res = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/general_progress', {
                            key: convertToPDFResponse_progress_key,
                        });
                        console.log("response from SERVER_IP_MULTIDOC /general_progress", res)

                        if (res.data.status === 200 && res.data.message.includes("replicate")) {
                            clearInterval(interval);
                            setIntervals(prevIntervals => {
                                const newIntervals = { ...prevIntervals };
                                delete newIntervals[scanFileID];
                                return newIntervals;
                            });
                            // download the url in res.data.message, which is a PDF file, and then upload it through the /convert/upload_file route
                            const pdfUrl = res.data.message;               // e.g. https://replicate.delivery/…/output.pdf
                            const { data: blob } = await axios.get(pdfUrl, { responseType: 'blob' });
                            const file = new File([blob], `text_${scanFileID}.pdf`, { type: 'application/pdf' });

                            const formData = new FormData();
                            formData.append('file', file, file.name);        // 3rd arg guarantees the filename
                            formData.append('user_id', localStorage.getItem('userID'));
                            formData.append('file_name', file.name);         // keeps backend happy
                            console.log("FORM DATA BELOW: ")
                            console.log(formData.get('file'));
                            console.log(formData.get('user_id'));
                            console.log(formData.get('file_name'));

                            const formUserID = localStorage.getItem("userID");
                            const formFilename = file.name;
                            const formMultidocID = generation.id;
                            const firstResponse = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/multidoc/get_pdf_upload_url', {
                                user_id: formUserID,
                                multidoc_id: formMultidocID,
                                filename: formFilename
                            });
                            console.log("firstResponse", firstResponse);
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 86 } : f));

                            const secondResponse = await axios.put(firstResponse.data.message.presigned_url, file, {
                                headers: {
                                    'Content-Type': 'application/pdf'
                                }
                            });

                            if (secondResponse.status === 200) {
                                console.log('PDF uploaded successfully AWS!', secondResponse);
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 91 } : f));
                            } else {
                                console.error('Failed to upload PDF AWS:', secondResponse.statusText);
                            }

                            console.log("complete_pdf_upload payload", {
                                user_id: formUserID,
                                multidoc_id: formMultidocID,
                                file_id: firstResponse.data.message.file_id
                            });
                            const response = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/multidoc/complete_pdf_upload', {
                                user_id: formUserID,
                                multidoc_id: formMultidocID,
                                file_id: firstResponse.data.message.file_id
                            });
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 99 } : f));
                            console.log('Uploaded MULTIDOC Response:', response);
                            if (response.data.message.message ===
                                "Scanned PDF detected, do you want to run OCR on this PDF? Call the proper follow up route if yes.") {
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'ocring' } : f));
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, id: response.data.message.file_id,
                                    estimatedTimeOCR: response.data.message.time_estimate_seconds } : f));
                                // const estimatedTimeOCR = response.data.message.time_estimate_seconds;
                                // track this estimated time for this specific file, so that we know how many seconds should go by before increasing the progress bar by 5%
                                // setFiles(files => files.map((f, i) => i === index ? { ...f, estimatedTimeOCR: estimatedTimeOCR } : f));
                                startDocumentProcessing(response.data.message.file_id, index)
                                return;
                            }
                            if (response.data.status === 400) {
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'error' } : f));
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                                toast({
                                    title: t('Your input is too large.'),
                                    description: t('We support up to 512 MB or 147,000 words'),
                                    status: "error",
                                    duration: 9000,
                                    isClosable: true,
                                })
                            }
                            else if (response.data.message === "Can upload a maximum of 8 sources in free tier. Please upgrade.") {
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'error' } : f));
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                                toast({
                                    title: t('Maximum of 8 sources allowed.'),
                                    status: "error",
                                    duration: 9000,
                                    isClosable: true,
                                })
                            }
                            else if (response.data.status === 401) {
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'error' } : f));
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                                toast({
                                    title: t('Oops, this file failed.'),
                                    description: t('Please try again or upload a different file.'),
                                    status: "error",
                                    duration: 9000,
                                    isClosable: true,
                                })
                                failedPDFNotification(localStorage.getItem("userID"), "Multi Doc Pasted Text Upload Fail for user " + localStorage.getItem("userID"), 
                                    file, serverIPs.SERVER_IP)
                            }
                            else if (response.data.status === 402 && response.data.message === "free tier exceeded. Please subscribe to continue using the service") {
                                console.log("pricing_modal_shown")
                                // remove the file
                                setFiles(files => files.filter((f, i) => f.id !== scanFileID));
                                toast({
                                    title: t('(Free Plan) Upload Limit Exceeded!'),
                                    status: "info",
                                    duration: 9000,
                                    isClosable: true,
                                    position: "top",
                                });
                                dispatch(setIsPricingModalOpen(true));
                                localStorage.setItem("isUploadExceeded", "true");
                                return;
                            } else if (response.data.status === 403) {
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'error' } : f));
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                                toast({
                                    title: t('Free Plan supports <= 20 pages for user inputted sources'),
                                    description: t('Visit the pricing page to view Pro Plan pricing'),
                                    status: "error",
                                    duration: null,
                                    isClosable: true,
                                })
                            }
                            else {
                                toast({
                                    title: t('Your Text has been Uploaded!'),
                                    status: "success",
                                    duration: 9000,
                                    isClosable: true,
                                });
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'completed' } : f));
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, id: response.data.message.file_id } : f));
                            }
                        }
                        else {
                            // NEED TO EDIT INSIDE THIS ELSE STATEMENT FOR SHOWING BETTER PROGRESS UPDATES TO USER AND BETTER TIMING ESTIMATE INSTEAD OF JUST GUESSING - done
                            console.log("still processing")
                            setFiles(files => {
                                const file = files.find(f => f.id === scanFileID);
                                console.log("file", file)
                                const estimatedTimeConversion = Math.ceil(file.size / (1024 * 1024)) * 10; // 10 seconds per MB
                                let increment = 5;
                                if (estimatedTimeConversion) {
                                    increment = 5 / (estimatedTimeConversion / 100);
                                    // round to the nearest integer
                                    increment = Math.round(increment);
                                }

                                return files.map((f, i) => f.id === scanFileID
                                    ? { ...f, progress: Math.min(f.progress + increment, 85) } : f);
                            });
                        }
                    }, 5000)
                    setIntervals(prevIntervals => ({ ...prevIntervals, [scanFileID]: interval }));
                }
            } catch (error) {
                console.error('server said →', error.response?.data);
                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'error' } : f));
                setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                console.log("startTextConversion error", error);
            }
        }
    }

    const startPDFConversion = async (scanFileID, formData2, fileIndex) => {
        setFiles(prev =>
            prev.map((file, i) =>
                i === fileIndex ? {...file, id: scanFileID} : file
            )
        );

        try {
            const convertToPDFResponse = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/convert/convert_to_pdf', formData2);
            console.log("response from /convert/convert_to_pdf", convertToPDFResponse)

            if (convertToPDFResponse.data.status === 200) {
                const convertToPDFResponse_file_id = convertToPDFResponse.data.message.file_id;
                const convertToPDFResponse_filename = convertToPDFResponse.data.message.filename;
                const convertToPDFResponse_progress_key = convertToPDFResponse.data.message.progress_key;

                const start = new Date().getTime() / 1000;

                // start polling another endpoint to check if the document is ready
                const interval = setInterval(async () => {
                    console.log("Pollkey", convertToPDFResponse_progress_key);
                    const res = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/general_progress', {
                        key: convertToPDFResponse_progress_key,
                    });
                    console.log("response from SERVER_IP_MULTIDOC /general_progress", res)
                    // {
                    //     "message": "https://replicate.delivery/yhqm/TMl76KaoSILfN6OJP0ztq6VHj5hvL2NXtezZddP2uBpXST6UA/output.pdf",
                    //     "status": 200
                    // }
                    if (res.data.status === 200 && res.data.message.includes("replicate")) {
                        clearInterval(interval);
                        setIntervals(prevIntervals => {
                            const newIntervals = { ...prevIntervals };
                            delete newIntervals[scanFileID];
                            return newIntervals;
                        });
                        // download the url in res.data.message, which is a PDF file, and then upload it through the /convert/upload_file route
                        const pdfUrl = res.data.message;               // e.g. https://replicate.delivery/…/output.pdf
                        const { data: blob } = await axios.get(pdfUrl, { responseType: 'blob' });
                        const file = new File([blob], `${convertToPDFResponse_filename}.pdf`, { type: 'application/pdf' });

                        const formData = new FormData();
                        formData.append('file', file, file.name);        // 3rd arg guarantees the filename
                        formData.append('user_id', localStorage.getItem('userID'));
                        formData.append('file_name', file.name);         // keeps backend happy
                        console.log("FORM DATA BELOW: ")
                        console.log(formData.get('file'));
                        console.log(formData.get('user_id'));
                        console.log(formData.get('file_name'));

                        const formUserID = localStorage.getItem("userID");
                        const formFilename = file.name;
                        const formMultidocID = generation.id;
                        const firstResponse = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/multidoc/get_pdf_upload_url', {
                            user_id: formUserID,
                            multidoc_id: formMultidocID,
                            filename: formFilename
                        });
                        console.log("firstResponse", firstResponse);
                        setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 86 } : f));

                        const secondResponse = await axios.put(firstResponse.data.message.presigned_url, file, {
                            headers: {
                                'Content-Type': 'application/pdf'
                            }
                        });

                        if (secondResponse.status === 200) {
                            console.log('PDF uploaded successfully AWS!', secondResponse);
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 91 } : f));
                        } else {
                            console.error('Failed to upload PDF AWS:', secondResponse.statusText);
                        }

                        console.log("complete_pdf_upload payload", {
                            user_id: formUserID,
                            multidoc_id: formMultidocID,
                            file_id: firstResponse.data.message.file_id
                        });
                        const response = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/multidoc/complete_pdf_upload', {
                            user_id: formUserID,
                            multidoc_id: formMultidocID,
                            file_id: firstResponse.data.message.file_id
                        });
                        setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 99 } : f));
                        console.log('Uploaded MULTIDOC Response:', response);
                        if (response.data.message.message ===
                            "Scanned PDF detected, do you want to run OCR on this PDF? Call the proper follow up route if yes.") {
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'ocring' } : f));
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, id: response.data.message.file_id,
                                estimatedTimeOCR: response.data.message.time_estimate_seconds } : f));
                            // const estimatedTimeOCR = response.data.message.time_estimate_seconds;
                            // track this estimated time for this specific file, so that we know how many seconds should go by before increasing the progress bar by 5%
                            // setFiles(files => files.map((f, i) => i === index ? { ...f, estimatedTimeOCR: estimatedTimeOCR } : f));
                            startDocumentProcessing(response.data.message.file_id, fileIndex)
                            return;
                        }
                        if (response.data.status === 400) {
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'error' } : f));
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                            toast({
                                title: t('File is too large.'),
                                description: t('We support up to 512 MB or 147,000 words'),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        }
                        else if (response.data.message === "Can upload a maximum of 8 sources in free tier. Please upgrade.") {
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'error' } : f));
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                            toast({
                                title: t('Maximum of 8 sources allowed.'),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        }
                        else if (response.data.status === 401) {
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'error' } : f));
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                            toast({
                                title: t('Oops, this file failed.'),
                                description: t('Please try again or upload a different file.'),
                                status: "error",
                                duration: 9000,
                                isClosable: true,
                            })
                        }
                        else if (response.data.status === 402 && response.data.message === "free tier exceeded. Please subscribe to continue using the service") {
                            console.log("pricing_modal_shown")
                            // remove the file
                            setFiles(files => files.filter((f, i) => f.id !== scanFileID));
                            toast({
                                title: t('(Free Plan) File Upload Limit Exceeded!'),
                                status: "info",
                                duration: 9000,
                                isClosable: true,
                                position: "top",
                            });
                            dispatch(setIsPricingModalOpen(true));
                            localStorage.setItem("isUploadExceeded", "true");
                            return;
                        } else if (response.data.status === 403) {
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'error' } : f));
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                            toast({
                                title: t('Free Plan supports <= 20 pages for scanned files'),
                                description: t('Visit the pricing page to view Pro Plan pricing'),
                                status: "error",
                                duration: null,
                                isClosable: true,
                            })
                        }
                        else {
                            toast({
                                title: t('File Uploaded!'),
                                status: "success",
                                duration: 9000,
                                isClosable: true,
                            });
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'completed' } : f));
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
                            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, id: response.data.message.file_id } : f));
                        }
                    }
                    else {
                        // NEED TO EDIT INSIDE THIS ELSE STATEMENT FOR SHOWING BETTER PROGRESS UPDATES TO USER AND BETTER TIMING ESTIMATE INSTEAD OF JUST GUESSING - done
                        console.log("still processing")
                        setFiles(files => {
                            const file = files.find(f => f.id === scanFileID);
                            console.log("file", file)
                            const estimatedTimeConversion = Math.ceil(file.size / (1024 * 1024)) * 10; // 10 seconds per MB
                            let increment = 5;
                            if (estimatedTimeConversion) {
                                increment = 5 / (estimatedTimeConversion / 100);
                                // round to the nearest integer
                                increment = Math.round(increment);
                            }

                            return files.map((f, i) => f.id === scanFileID
                                ? { ...f, progress: Math.min(f.progress + increment, 85) } : f);
                        });
                    }
                }, 5000)
                setIntervals(prevIntervals => ({ ...prevIntervals, [scanFileID]: interval }));
            }
        } catch (error) {
            console.error('server said →', error.response?.data);
            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, status: 'error' } : f));
            setFiles(files => files.map((f, i) => f.id === scanFileID ? { ...f, progress: 0 } : f));
            console.log("startPDFConversion error", error);
        }
    };

    const stopPolling = (scanFileID, fileIndex) => {
        if (intervals[scanFileID]) {
            // remove the file
            setFiles(files => files.filter((f, i) => f.id !== scanFileID));
            clearInterval(intervals[scanFileID]);
            setIntervals(prevIntervals => {
                const newIntervals = { ...prevIntervals };
                delete newIntervals[scanFileID];
                return newIntervals;
            });
        }
    };

    const handleFileDelete = async (generationID, fileID, statusBefore) => {
        const userID = auth.isLoggedIn ? localStorage.getItem("userID") : "11111111-1111-1111-1111-111111111111";

        console.log("request body for remove_source_multidoc", {
            user_id: userID,
            multidoc_id: generationID,
            file_id: fileID,
            multidoc_session_id: currentGenerationSessionToken !== "" ? currentGenerationSessionToken : null
        })
        try {
            const response = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/multidoc/remove_source_multidoc', {
                user_id: userID,
                multidoc_id: generationID,
                file_id: fileID,
                multidoc_session_id: currentGenerationSessionToken !== "" ? currentGenerationSessionToken : null
            });
            console.log('Remove Source Multidoc Response:', response);
            if (response.data.status === 200) {
                setFiles(files => files.filter(f => f.id !== fileID));
                return 200;
            } else if (response.data.status === 401) {
                toast({
                    title: t('Must have at least 1 source.'),
                    description: t('Please upload another source before removing this one.'),
                    status: "error",
                    duration: 9000,
                    isClosable: true,
                })
                setFiles(files => files.map((f) => f.id === fileID ? { ...f, status: statusBefore } : f));
            }
        } catch (error) {
            toast({
                title: t('Oops, something went wrong. Please try again.'),
                status: "error",
                duration: 9000,
                isClosable: true,
            })
            console.error('Error removing the source:', error);
        }
    }

    const handleFileUpload = async (fileObj, index) => {
        if (localStorage.getItem("userID") !== null) {
            if (fileObj.type === 'application/pdf') {
                if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                    toast({
                        title: t('(Free Plan) PDF Upload Limit Exceeded!'),
                        status: "info",
                        duration: 9000,
                        isClosable: true,
                        position: "top",
                    });
                    dispatch(setIsPricingModalOpen(true));
                    setFiles(files => files.filter((f, i) => i !== index));
                    return;
                }

                setFiles(files => files.map((f, i) => i === index ? { ...f, status: 'uploading' } : f));

                const formData = new FormData();
                const formUserID = localStorage.getItem("userID");
                const formFilename = fileObj.name;
                const formMultidocID = generation.id;
                const formFile = fileObj.file;
                formData.append('file', formFile);
                formData.append('user_id', formUserID);
                formData.append('filename', formFilename);
                formData.append('multidoc_id', formMultidocID)
                // console.log("FORM DATA BELOW: ")
                // console.log(formData.forEach((value, key) => console.log(key + ' ' + value)));

                let uploadedFileID = null;

                const tryRepairAndOcr = async () => {
                    try {
                        console.log("/multidoc/repair_and_ocr payload", {
                            user_id: formUserID,
                            multidoc_id: formMultidocID,
                            file_id: uploadedFileID,
                            filename: formFilename
                        });
                        const repairResponse = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/multidoc/repair_and_ocr', {
                            user_id: formUserID,
                            multidoc_id: formMultidocID,
                            file_id: uploadedFileID,
                            filename: formFilename
                        });
                        console.log('repair_and_ocr response:', repairResponse);
                        if (repairResponse.data.status === 200) {
                            const fileIDHere = repairResponse.data.message.file_id;
                            const taskIDHere = repairResponse.data.message.task_id;
                            startRepairOcrPolling(fileIDHere, taskIDHere, index);
                            return true;
                        }
                        throw new Error("repair_and_ocr returned non-200: " + repairResponse.data.status);
                    } catch (repairError) {
                        console.error('/multidoc/repair_and_ocr error', repairError);
                        setFiles(files => files.map((f, i) => i === index ? { ...f, status: 'error' } : f));
                        setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 0 } : f));
                        toast({
                            title: t('Oops, this file failed.'),
                            description: t('Please try again or upload a different file.'),
                            status: "error",
                            duration: 9000,
                            isClosable: true,
                        })
                        failedPDFNotification(localStorage.getItem("userID"), "Multi Doc Upload Fail for user " + localStorage.getItem("userID"), formFile, serverIPs.SERVER_IP)
                        return false;
                    }
                };

                try {
                    console.log("/multidoc/get_pdf_upload_url payload", {
                        user_id: formUserID,
                        multidoc_id: formMultidocID,
                        filename: formFilename
                    })
                    console.log(serverIPs.SERVER_IP_MULTIDOC);
                    const firstResponse = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/multidoc/get_pdf_upload_url', {
                        user_id: formUserID,
                        multidoc_id: formMultidocID,
                        filename: formFilename
                    });
                    console.log("firstResponse", firstResponse);
                    uploadedFileID = firstResponse.data.message.file_id;
                    setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 10 } : f));



                    const secondResponse = await axios.put(firstResponse.data.message.presigned_url, formFile, {
                        headers: {
                            'Content-Type': 'application/pdf'
                        }
                    });

                    if (secondResponse.status === 200) {
                        console.log('PDF uploaded successfully AWS!', secondResponse);
                        setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 24 } : f));
                    } else {
                        console.error('Failed to upload PDF AWS:', secondResponse.statusText);
                    }



                    console.log("complete_pdf_upload payload", {
                        user_id: formUserID,
                        multidoc_id: formMultidocID,
                        file_id: firstResponse.data.message.file_id
                    });
                    const response = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/multidoc/complete_pdf_upload', {
                        user_id: formUserID,
                        multidoc_id: formMultidocID,
                        file_id: firstResponse.data.message.file_id
                    }, {
                        onUploadProgress: (progressEvent) => {
                            console.log("Progress Event", progressEvent);
                            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                            setFiles(files => files.map((f, i) => i === index ? { ...f, progress: percentCompleted } : f));
                        }
                    });
                    console.log('Uploaded MULTIDOC Response:', response);
                    if (response.data.message === "file could not be processed. You may attempt to repair this PDF by calling /multidoc/repair_and_ocr") {
                        await tryRepairAndOcr();
                        return;
                    }
                    if (response.data.message.message ===
                        "Scanned PDF detected, do you want to run OCR on this PDF? Call the proper follow up route if yes.") {
                        setFiles(files => files.map((f, i) => i === index ? { ...f, status: 'ocring' } : f));
                        setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 0 } : f));
                        setFiles(files => files.map((f, i) => i === index ? { ...f, id: response.data.message.file_id,
                            estimatedTimeOCR: response.data.message.time_estimate_seconds } : f));
                        // const estimatedTimeOCR = response.data.message.time_estimate_seconds;

                        // track this estimated time for this specific file, so that we know how many seconds should go by before increasing the progress bar by 5%
                        // setFiles(files => files.map((f, i) => i === index ? { ...f, estimatedTimeOCR: estimatedTimeOCR } : f));
                        startDocumentProcessing(response.data.message.file_id, index)
                        return;
                    }
                    if (response.data.status === 400) {
                        setFiles(files => files.map((f, i) => i === index ? { ...f, status: 'error' } : f));
                        setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 0 } : f));
                        toast({
                            title: t('File is too large.'),
                            description: t('We support up to 512 MB or 147,000 words'),
                            status: "error",
                            duration: 9000,
                            isClosable: true,
                        })
                    }
                    else if (response.data.message === "Can upload a maximum of 8 sources in free tier. Please upgrade.") {
                        setFiles(files => files.map((f, i) => i === index ? { ...f, status: 'error' } : f));
                        setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 0 } : f));
                        toast({
                            title: t('Maximum of 8 sources allowed on Free Plan'),
                            status: "error",
                            duration: 9000,
                            isClosable: true,
                        })
                        dispatch(setIsPricingModalOpen(true));
                    }
                    else if (response.data.status === 401) {
                        setFiles(files => files.map((f, i) => i === index ? { ...f, status: 'error' } : f));
                        setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 0 } : f));
                        toast({
                            title: t('Oops, this file failed.'),
                            description: t('Please try again or upload a different file.'),
                            status: "error",
                            duration: 9000,
                            isClosable: true,
                        })
                        failedPDFNotification(localStorage.getItem("userID"), "Multi Doc Upload Fail for user " + localStorage.getItem("userID"), 
                            formFile, serverIPs.SERVER_IP)
                    }
                    else if (response.data.status === 402 && response.data.message === "free tier exceeded. Please subscribe to continue using the service") {
                        console.log("pricing_modal_shown")
                        // remove the file
                        setFiles(files => files.filter((f, i) => i !== index));
                        toast({
                            title: t('(Free Plan) File Upload Limit Exceeded!'),
                            status: "info",
                            duration: 9000,
                            isClosable: true,
                            position: "top",
                        });
                        dispatch(setIsPricingModalOpen(true));
                        localStorage.setItem("isUploadExceeded", "true");
                        return;
                    } else if (response.data.message.status === 403) {
                        setFiles(files => files.map((f, i) => i === index ? { ...f, status: 'error' } : f));
                        setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 0 } : f));
                        toast({
                            title: t('Free Plan supports <= 20 pages for scanned files'),
                            description: t('Visit justifyai.app/pricing to view Pro Plan pricing'),
                            status: "error",
                            duration: null,
                            isClosable: true,
                        })
                        dispatch(setIsPricingModalOpen(true));
                    }
                    else {
                        // addActiveSourcesMultidoc(sessionTokenGeneration, localStorage.getItem("userID"),
                        //         [response.data.message.file_id]);
                        setFiles(files => files.map((f, i) => i === index ? { ...f, status: 'completed' } : f));
                        setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 0 } : f));
                        setFiles(files => files.map((f, i) => i === index ? { ...f, id: response.data.message.file_id } : f));
                    }
                } catch (error) {
                    console.error('Error uploading the document:', error);
                    await tryRepairAndOcr();
                }
            } else {
                if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                    toast({
                        title: t('(Free Plan) File Upload Limit Exceeded!'),
                        status: "info",
                        duration: 9000,
                        isClosable: true,
                        position: "top",
                    });
                    dispatch(setIsPricingModalOpen(true));
                    setFiles(files => files.filter((f, i) => i !== index));
                    return;
                }

                setFiles(files => files.map((f, i) => i === index ? { ...f, status: 'uploading' } : f));

                const formData = new FormData();
                const formUserID = localStorage.getItem("userID");
                const formFile = fileObj.file;
                formData.append('file', formFile);
                formData.append('user_id', formUserID);

                try {
                    // if the file size is greater than 15 MB
                    if (formFile.size > 15 * 1024 * 1024) {
                        // 1️⃣  INITIATE
                        let fileExtension = getFileExtension(formFile);
                        console.log("fileExtension", fileExtension)

                        // remove the . from the beginning of the file extension
                        fileExtension = fileExtension.startsWith('.') ? fileExtension.slice(1) : fileExtension;

                        const initiateResponse = await initiateMultipartUploadConversion(
                            serverIPs.SERVER_IP_MULTIDOC,
                            localStorage.getItem("userID"),
                            formFile.name,
                            formFile.size,
                            fileExtension
                        );
                        const file_id = initiateResponse.file_id;
                        const presigned_urls = initiateResponse.presigned_urls;
                        setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 5 } : f));

                        // 2️⃣  UPLOAD PARTS—use the onPartComplete callback for exact percent
                        const etagValues = await uploadMultipartPartsConversion(
                            formFile,
                            presigned_urls,
                            (percent) => setFiles(files => files.map((f, i) => i === index ? { ...f, progress: percent } : f))
                        );

                        // 3️⃣  COMPLETE
                        const lastResponse = await completeMultipartUploadConversion(
                            serverIPs.SERVER_IP_MULTIDOC,
                            localStorage.getItem("userID"),
                            file_id,
                            etagValues
                        );
                        setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 10 } : f));

                        const formData23 = new FormData();
                        formData23.append('user_id', lastResponse.data.message.user_id);
                        formData23.append('file_id', lastResponse.data.message.file_id);
                        formData23.append('filename_secure', lastResponse.data.message.filename);
                        formData23.append('file_extension', fileExtension);
                        formData23.append('socketio_stream_room', 'user_' + localStorage.getItem('userID'));

                        startPDFConversion(lastResponse.data.message.file_id, formData23, index);
                    }

                    // everything in the else statement below was the original code before June 28
                    else {
                        console.log("/convert/upload_file FORM DATA BELOW: ")
                        console.log(formData.forEach((value, key) => console.log(key + ' ' + value)));

                        setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 5 } : f));
                        const singleUploadFileResponse = await axios.post(serverIPs.SERVER_IP_MULTIDOC + '/convert/upload_file', formData);
                        console.log("singleUploadFileResponse", singleUploadFileResponse);
                        setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 10 } : f));

                        if (singleUploadFileResponse.data.status === 200) {
                            const singleUploadFileResponse_message = singleUploadFileResponse.data.message.message;
                            const singleUploadFileResponse_file_id = singleUploadFileResponse.data.message.file_id;
                            const singleUploadFileResponse_user_id = singleUploadFileResponse.data.message.user_id;
                            const singleUploadFileResponse_filename_secure = singleUploadFileResponse.data.message.filename_secure;
                            const singleUploadFileResponse_file_extension = singleUploadFileResponse.data.message.file_extension;

                            const formData2 = new FormData();
                            formData2.append('user_id', singleUploadFileResponse_user_id);
                            formData2.append('file_id', singleUploadFileResponse_file_id);
                            formData2.append('filename_secure', singleUploadFileResponse_filename_secure);
                            formData2.append('file_extension', singleUploadFileResponse_file_extension);
                            formData2.append('socketio_stream_room', 'user_' + localStorage.getItem('userID'));

                            startPDFConversion(singleUploadFileResponse_file_id, formData2, index);
                        } else if (singleUploadFileResponse.data.status === 400 && singleUploadFileResponse.data.message.includes("is not supported")) {
                            setFiles(files => files.map((f, i) => i === index ? { ...f, status: 'error' } : f));
                            setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 0 } : f));
                            toast({
                                title: t("This file type isn't supported"),
                                description: "We support .pdf, .png, .jpg, " +
                                    ".docx, .pptx, .xlsx, .txt, .csv, .html, .epub, .key, .mp4, .mp3, .mov, .rtf, .pages, .numbers",
                                status: "error",
                                duration: 11000,
                                isClosable: true,
                            })
                        }
                    }
                } catch (error) {
                    setFiles(files => files.map((f, i) => i === index ? { ...f, status: 'error' } : f));
                    setFiles(files => files.map((f, i) => i === index ? { ...f, progress: 0 } : f));
                    toast({
                        title: t('Oops, this file failed.'),
                        description: t('Please try again or upload a different file.'),
                        status: "error",
                        duration: 9000,
                        isClosable: true,
                    })
                    failedPDFNotification(localStorage.getItem("userID"), "Multi Doc Upload Fail for user " + localStorage.getItem("userID"), formFile, serverIPs.SERVER_IP)
                    console.error('Error uploading the file:', error);
                }
            }
        }
    };


    const { isOpen, onToggle } = useDisclosure();
    const [freeText, setFreeText]       = useState('');
    const [isUploading, setIsUploading] = useState(false);  // ▲ loading flag
    const uploadTimerRef = useRef(null);      // ▲ holds the timeout id

    function handleTextUpload() {
        if (!freeText.trim()) {
            toast(
                {
                    title: t('Please enter some text before submitting.'),
                    status: "warning",
                    duration: 5000,
                    isClosable: true,
                    position: "bottom",
                    variant: "subtle",

                }
            )
            return;
        }

        console.log('submitted text:', freeText);

        startTextConversion(localStorage.getItem("userID"), freeText);

        setIsUploading(true);                   // show spinner + text
        setFreeText('');                        // clear textarea immediately

        // start 2-second fake upload
        uploadTimerRef.current = window.setTimeout(() => {
            setIsUploading(false);                // back to normal state
            onToggle();
        }, 2500);
    }
    return (
        <>
            <Modal isOpen={isOpenGeneratePromptScreen2} onClose={closeModal} isCentered size="xl" closeOnOverlayClick={false}>
                <ModalOverlay />
                <ModalContent borderRadius="1rem" p="0.75rem" h="42rem" maxW="50rem" overflowY="auto" position="relative">
                    {canCloseModal() ?
                        <Box
                            position="absolute"
                            top="10px"
                            right="10px"
                            zIndex={999}
                        >
                            <CloseButton
                                size="md"
                                onClick={() => {
                                    closeModal();
                                }}
                                bg="transparent"
                                borderRadius="50%"
                                _hover={{
                                    bg: "gray.200",
                                    borderRadius: "50%",
                                }}
                            />
                        </Box> : null}
                    <Flex alignItems="center" justifyContent="space-between" p={4} >
                        <VStack align="flex-start" width={'100%'} spacing={5}>
                            <Text fontSize="xl" fontWeight="bold" my={-1}>{t('Upload Sources')}</Text>
                            <VStack align="flex-start" width={'100%'} spacing={2}>
                                <Text fontSize={15} fontWeight="normal">Get responses based on your reports and other uploaded sources, with in-text citations.</Text>
                            </VStack>
                        </VStack>
                    </Flex>
                    <ModalBody>
                        <Stack spacing={4} mt={1}>
                            <FormControl id="prompt" isRequired>
                                <VStack spacing={4} bg={'white'}>
                                    <MotionBox
                                        {...getRootProps()}
                                        border="2px"
                                        borderColor="orange.400"
                                        borderRadius="md"
                                        borderStyle="dashed"
                                        textAlign="center"
                                        p="2"
                                        cursor="pointer"
                                        _hover={{ bg: 'gray.100' }}
                                        animate={isDragActive ? { scale: 1.05 } : { scale: 1 }}
                                        transition={{ duration: 0.2 }}
                                        width="100%"
                                        height={'8.2rem'}
                                        onClick={() => {
                                            if (getDocumentsInStorage().length === 1 && !auth.isLoggedIn) {
                                                toast({
                                                    title: t("You've reached your document limit in guest mode!"),
                                                    description: t('Please sign up to continue uploading documents.'),
                                                    status: "info",
                                                    duration: 9000,
                                                    isClosable: true,
                                                    position: "top",
                                                });
                                                onOpenSignUpScreen1();
                                            }
                                            else if (!JSON.parse(localStorage.getItem("isProPlan")) && localStorage.getItem("isUploadExceeded") === "true") {
                                                toast({
                                                    title: t('(Free Plan) PDF Upload Limit Exceeded!'),
                                                    status: "info",
                                                    duration: 9000,
                                                    isClosable: true,
                                                    position: "top",
                                                });
                                                dispatch(setIsPricingModalOpen(true));
                                            }
                                            else {
                                                fileInput.current.click();
                                            }
                                        }}
                                    >
                                        <input {...getInputProps()} ref={fileInput}/>
                                        <Box as="span" color="gray.400" fontSize="3xl">
                                            ⇧
                                        </Box>
                                        <Text fontWeight="bold" color="gray.400" fontSize={"sm"}>
                                            {t('Drag & Drop')}
                                        </Text>
                                        <Text color="gray.500" fontSize={"sm"}>{t('or click to browse')}</Text>
                                    </MotionBox>

                                    {/*put an open text box here where user can type in or paste in any free-form text*/}
                                    <Box w="100%" my={-1}>
                                        {/* clickable bar */}
                                        <Flex
                                            align="center"
                                            justify="space-between"
                                            bg="gray.50"
                                            px={3}
                                            py={2}
                                            borderRadius="md"
                                            cursor="pointer"
                                            _hover={{ bg: 'gray.100' }}
                                            onClick={onToggle}
                                        >
                                            <Text fontWeight="medium" fontSize={14}>
                                                Paste in your own text as a source
                                            </Text>
                                            <Icon as={isOpen ? ChevronUp : ChevronDown} boxSize={5} />
                                        </Flex>

                                        {/* collapsible textarea */}
                                        <Collapse in={isOpen} animateOpacity>
                                            <Box
                                                mt={2}
                                                bg="white"
                                                border="1px solid"
                                                borderColor="gray.200"
                                                borderRadius="md"
                                                p={0}
                                                position="relative"
                                            >
                                                <Textarea
                                                    value={freeText}
                                                    onChange={(e) => setFreeText(e.target.value)}
                                                    placeholder="Type or paste any text…"
                                                    resize="vertical"
                                                    minH="8rem"
                                                    pr="4.5rem"           /* leave room for the button */
                                                />

                                                <Button
                                                    colorScheme="blue"
                                                    size="sm"
                                                    isLoading={isUploading}      // ▲ Chakra shows spinner+loadingText
                                                    loadingText="Uploading…see below for progress"     //   while isLoading === true
                                                    onClick={handleTextUpload}       // ▲
                                                    position="absolute"
                                                    bottom="0rem"
                                                    right="0rem"
                                                    zIndex={999}
                                                >
                                                    Upload
                                                </Button>
                                            </Box>
                                        </Collapse>
                                    </Box>
                                </VStack>
                            </FormControl>

                            <VStack
                                align="flex-start"
                                width={'100%'}
                                spacing={0}
                                mt={'0rem'}
                                height="270px"
                                overflowY="auto"
                                sx={{
                                    '&::-webkit-scrollbar': {
                                        width: '8px',
                                        borderRadius: '8px',
                                        backgroundColor: 'rgba(0, 0, 0, 0.05)',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                                        borderRadius: '8px',
                                    },
                                }}
                            >
                                {files.map((file, i) => {
                                    return(
                                        <HStack
                                            key={i} // Unique key for each item
                                            w="100%"
                                            alignItems="center"
                                            mt={1}
                                            borderWidth="1px"
                                            borderRadius="md"
                                            borderColor="gray.200"
                                            px={2}
                                            py={2}
                                            boxShadow="sm"
                                        >
                                            <Icon as={ImFilePdf} mx={2}></Icon>
                                            <VStack align={'flex-start'} width={'85%'} >
                                                <Text fontWeight="bold" fontSize={"sm"} noOfLines={2} // Set to 2 lines
                                                      wordBreak="break-word">{file.name}</Text>
                                                <HStack justify={'space-between'} align={'space-between'} width={'100%'}>
                                                    <Text color="gray.500" fontSize={"xs"}>{(file.size / 1024 / 1024).toFixed(2)} MB</Text>
                                                    {(file.status === 'uploading' || file.status === 'ocring' || file.status === 'repairing') && (
                                                        file.status === "repairing" ?
                                                            <Text color="black" fontSize={"xs"}>{t("initial upload failed, repairing this now....")}{Math.round(file.animatedProgress)}%</Text> :
                                                        file.status === "ocring" ?
                                                            <Text color="black" fontSize={"xs"}>{t("scanning, this may take a bit longer...")}{Math.round(file.animatedProgress)}%</Text> :
                                                            <Text color="black" fontSize={"xs"}>{Math.round(file.animatedProgress)}%</Text>
                                                    )}
                                                </HStack>
                                                {(file.status === 'uploading' || file.status === 'ocring' || file.status === 'repairing') && (
                                                    <AnimatedProgress
                                                        key={file.id}
                                                        colorScheme="pink"
                                                        size="xs"
                                                        width="100%"
                                                        my={1}
                                                        value={Math.max(0, file.progress - 1)}
                                                        onProgressChange={(animatedValue) => {
                                                            setFiles(prevFiles => 
                                                                prevFiles.map(f => 
                                                                    f.id === file.id 
                                                                        ? { ...f, animatedProgress: animatedValue } 
                                                                        : f
                                                                )
                                                            );
                                                        }}
                                                    />
                                                )}
                                            </VStack>
                                            <Spacer />
                                            {file.status === 'error' ?
                                                <Text color="red" fontSize={"xs"}>{t('Error')}</Text>
                                                :
                                                file.status !== 'uploading' &&
                                                <Button colorScheme="gray" size="xs" variant="ghost"
                                                        isLoading={file.status === 'removing'}
                                                        onClick={() => {
                                                            console.log("Removing file", file.id, i)
                                                            if (file.status === 'ocring' || file.status === 'repairing') {
                                                                const statusBefore = file.status;
                                                                setFiles(files => files.map((f) => f.id === file.id ? { ...f, status: 'removing' } : f));
                                                                handleFileDelete(generation.id, file.id, statusBefore).then(r => {
                                                                    console.log("r response", r)
                                                                    if (r === 200) {
                                                                        stopPolling(file.id, i);
                                                                    }
                                                                });
                                                            } else {
                                                                const statusBefore = file.status;
                                                                setFiles(files => files.map((f) => f.id === file.id ? { ...f, status: 'removing' } : f));
                                                                handleFileDelete(generation.id, file.id, statusBefore).then(r => {
                                                                    console.log("r response", r)
                                                                });
                                                            }
                                                        }}>
                                                    <Icon as={CloseIcon} />
                                                </Button>
                                            }
                                        </HStack>
                                        )
                                })}
                            </VStack>
                            {files.length > 0 ?

                            <Flex width="100%" justify="center" mt={2}>
                                <Button
                                    loadingText="Uploading..."
                                    size="lg"
                                    isLoading={isLoading}
                                    isDisabled={files.some(file => file.status === 'uploading' || file.status === 'ocring' || file.status === 'repairing')}
                                    onClick={uploadSources}
                                    bgGradient={'linear(to-r, red.400,pink.400)'}
                                    color={'white'}
                                    width={'55%'}
                                    _hover={{
                                        boxShadow: 'xl',
                                    }}
                                >
                                    {t('Upload')}
                                </Button>
                            </Flex>
                        : null}

                        </Stack>
                    </ModalBody>
                    {/* {files.length > 0 ?
                        <ModalFooter>
                            <Flex width="100%" justify="center">
                                <Button
                                    loadingText="Uploading..."
                                    size="lg"
                                    isLoading={isLoading}
                                    isDisabled={files.some(file => file.status === 'uploading' || file.status === 'ocring' || file.status === 'repairing')}
                                    onClick={uploadSources}
                                    bgGradient={'linear(to-r, red.400,pink.400)'}
                                    color={'white'}
                                    width={'55%'}
                                    _hover={{
                                        boxShadow: 'xl',
                                    }}
                                >
                                    {t('Upload')}
                                </Button>
                            </Flex>
                        </ModalFooter> : null} */}
                </ModalContent>
            </Modal>

            <SignUpScreen1 isOpenSignUpScreen1={isOpenSignUpScreen1} onCloseSignUpScreen1={onCloseSignUpScreen1} onOpenSignInScreen1={onOpenSignInScreen1}/>
            <SignInScreen1 isOpenSignInScreen1={isOpenSignInScreen1} onCloseSignInScreen1={onCloseSignInScreen1} onOpenSignUpScreen1={onOpenSignUpScreen1}/>
            <ScanModal1 isOpenScanModal1={isOpenScanModal1} onCloseScanModal1={onCloseScanModal1} onOpenScanModal1={onOpenScanModal1}/>
            <ScanModalIntro1 isOpenScanModalIntro1={isOpenScanModalIntro1} onCloseScanModalIntro1={onCloseScanModalIntro1}
                             onOpenScanModalIntro1={onOpenScanModalIntro1}/>
        </>
    );
};

export default GeneratePromptScreen2;








